import React, {Component} from 'react';

import {APIClient} from "../../utils/APIClient";
import {API_URL} from "../../settings/local_settings";
import {AgencyHeader} from "./AgencyHeader";
import {InviteUserModal, EditUserModalInline} from "../invitations/InviteUserModal";
import {Spinner} from "../Spinner";
import {DeleteUserModal} from "./DeleteUserModal";
import {DeleteInvitationModal} from "./DeleteInvitationModal";
import {LocalStorage} from "../../utils/LocalStorage";
import {AgencyTabs} from "./AgencyTabs";
import {EditClientFeaturesModal} from "./EditClientFeaturesModal";
import {withRouterParams} from "../../utils/withRouterParams";
import { withTranslation } from 'react-i18next';

class AgencyTeam extends Component {
    render() {
        return (
            <AgencyTeamContent agencyId={this.props.match.params.id} />
        )
    }
}


class AgencyTeamContentClass extends Component {
    constructor(props) {
        super(props);
        this.state = {
            team: null,
            invitations: null,
            canEditTeam: null,
            canAssignClients: null,
            canAddClientUser: true,
            canInviteClientUser: false,
            isSuperAdmin: false,
            moduleAccessConfigurationEnabled: null,
            clientUsersLimitInfo: null
        };
        this.refreshUserName = this.refreshUserName.bind(this);
        this.removeDeletedUser = this.removeDeletedUser.bind(this);
        this.removeDeletedInvitation = this.removeDeletedInvitation.bind(this);
        this.handleNewUserWasInvited = this.handleNewUserWasInvited.bind(this);
    }

    redirectToAgencyRegisterPage() {
        this.props.history.push('/agency-register');
    }

    componentDidMount() {
        this.updateTeam();
    }

    updateTeam() {
        new APIClient(API_URL + 'agency/team/').call('GET').then((data) => {
            if (data.status === 'ERROR_NO_AGENCY') {
                alert(data['error_message']);
                this.redirectToAgencyRegisterPage()
            } else if (data.status === 'OK') {
                this.setState({
                    team: data.team,
                    invitations: data.invitations,
                    canEditTeam: data.can_edit_team,
                    canAssignClients: data.can_assign_clients,
                    canAddClientUser: data.can_add_client_user !== false,
                    canInviteClientUser: data.can_invite_client_user || false,
                    isSuperAdmin: data.is_super_admin || false,
                    moduleAccessConfigurationEnabled: data.module_access_configuration_enabled,
                    clientUsersLimitInfo: data.client_users_limit_info || null
                });
            }
        })
    }

    handleNewUserWasInvited() {
        const { t } = this.props;
        alert(t('agency_team.invitation_sent_successfully'));
        this.updateTeam();
    }

    renderTeam() {
        if (this.state.team !== null && this.state.invitations !== null) {
            return (
                <div className="table-box">
                    <table className="table table-striped">
                        <thead>
                        <tr>
                            <th>{this.props.t('agency_team.user')}</th>
                            <th>{this.props.t('agency_team.email')}</th>
                            {this.renderUserTypeColumnHeader()}
                            <th/>
                        </tr>
                        </thead>
                        <tbody>
                        {this.renderUsers()}
                        {this.renderInvitations()}
                        </tbody>
                    </table>
                </div>
            )
        } else {
            return (
                <div className="box-loader">
                    <Spinner color="positive"/>
                </div>
            )
        }
    }

    renderInviteTeam() {
        if (this.state.canEditTeam) {
            return (<InviteUserModal onUserInvited={this.handleNewUserWasInvited}
                                     moduleAccessConfigurationEnabled={this.state.moduleAccessConfigurationEnabled}
                                     canAddClientUser={this.state.canAddClientUser}
                                     clientUsersLimitInfo={this.state.clientUsersLimitInfo}
                                     isSuperAdmin={this.state.isSuperAdmin}/>);
        } else if (this.state.canInviteClientUser && this.state.canAssignClients) {
            return (<InviteUserModal onUserInvited={this.handleNewUserWasInvited}
                                     moduleAccessConfigurationEnabled={this.state.moduleAccessConfigurationEnabled}
                                     canAddClientUser={this.state.canAddClientUser}
                                     clientUsersLimitInfo={this.state.clientUsersLimitInfo}
                                     clientOnly={true}
                                     isSuperAdmin={this.state.isSuperAdmin}/>);
        }
    }

    render() {
        return (
            <section className="section-content agency-page agency-team-page">
                <AgencyHeader/>
                {this.renderTabs()}
                <div className="section-body h-items">
                    <div className="section-body-item -wider box">
                        <header className="box-header">
                            <h2 className="box-title">{this.props.t('agency_team.team')}</h2>
                            {this.renderInviteTeam()}
                        </header>
                        {this.renderTeam()}
                    </div>
                </div>
            </section>
        )
    }

    renderTabs() {
        return <AgencyTabs activeTab="-second"/>
    }

    renderInvitationOperation(invitation) {
        if(this.state.canEditTeam)
            return <DeleteInvitationModal removeDeletedInvitation={this.removeDeletedInvitation} invitationId={invitation.id}/>
    }

    renderInvitations() {
        return this.state.invitations.map((invitation) => {
            return (
                <tr key={invitation.id}>
                    <td><p className="generic-alert">{this.props.t('agency_team.pending_invitation')}</p></td>
                    <td>{invitation.email}</td>
                    {this.renderInvitationTypeColumnData(invitation)}
                    <td className="action-cell">
                        {this.renderInvitationOperation(invitation)}
                    </td>
                </tr>
            );
        });
    }

    renderInvitationTypeColumnData(invitation) {
        if(!this.showUserTypeColumn())
            return;
        return (<td></td>)
    }

    renderClientUserOperation(user) {
        const canEdit = this.state.canEditTeam || this.state.canAssignClients;
        if (!canEdit) return null;
        return (
            <div>
                <div style={{display: "inline-block", verticalAlign: "middle"}}>
                    <EditClientFeaturesModal user={user} onSaved={() => this.updateTeam()}/>
                </div>
                {this.state.canEditTeam && (
                    <div style={{display: "inline-block", verticalAlign: "middle", paddingLeft: "0.5em"}}>
                        <DeleteUserModal removeDeletedUser={this.removeDeletedUser} userId={user.id}/>
                    </div>
                )}
            </div>
        );
    }

    renderUserOperation(user) {
        if (user.user_type === 'Client') {
            return this.renderClientUserOperation(user);
        }
        if(this.state.canAssignClients && !this.state.canEditTeam) {
            return <div>
                <div style={{display: "inline-block", verticalAlign: "middle"}}>
                    <EditUserModalInline
                        user={user}
                        onSaved={() => this.updateTeam()}
                        moduleAccessConfigurationEnabled={this.state.moduleAccessConfigurationEnabled}
                        canAddClientUser={this.state.canAddClientUser}
                        isSuperAdmin={this.state.isSuperAdmin}
                    />
                </div>
            </div>
        }else if(LocalStorage.fetchUserId() === user.id || this.state.canEditTeam) {
            return (<div>
                <div style={{display: "inline-block", verticalAlign: "middle"}}>
                    <EditUserModalInline
                        user={user}
                        onSaved={() => this.updateTeam()}
                        moduleAccessConfigurationEnabled={this.state.moduleAccessConfigurationEnabled}
                        canAddClientUser={this.state.canAddClientUser}
                        isSuperAdmin={this.state.isSuperAdmin}
                    />
                </div>
                <div style={{display: "inline-block", verticalAlign: "middle", paddingLeft: "0.5em"}}>
                    <DeleteUserModal removeDeletedUser={this.removeDeletedUser} userId={user.id}/>
                </div>
            </div>)
        }
    }

    renderUsers() {
        return this.state.team.map((user) => {
            return (
                <tr key={user.id}>
                    <td>{user.name}</td>
                    <td>{user.email}</td>
                    {this.renderUserTypeColumnData(user)}
                    <td className="action-cell ">
                        {this.renderUserOperation(user)}
                    </td>
                </tr>
            );
        });
    }

    showUserTypeColumn() {
        return this.state.moduleAccessConfigurationEnabled;
    }

    renderClientFeatureBadges(features) {
        if (!features) return null;
        const { t } = this.props;
        const featureLabels = {
            connect: t('invite_user.feature_connect'),
            reports: t('invite_user.feature_reports'),
            dashboard: t('invite_user.feature_dashboard'),
            data_explorer: t('invite_user.feature_data_explorer'),
            insights: t('invite_user.feature_insights'),
        };
        const activeFeatures = Object.entries(features).filter(([, v]) => v);
        if (activeFeatures.length === 0) return null;
        return (
            <div className="team-client-features">
                {activeFeatures.map(([key]) => (
                    <span key={key} className="team-feature-badge">{featureLabels[key]}</span>
                ))}
            </div>
        );
    }

    renderUserTypeColumnData(user) {
        if(!this.showUserTypeColumn())
            return;
        let content = "";
        if (user.user_type === "Client") {
            content = (
                <div className="team-client-info">
                    <div className="team-client-header">
                        <span className="badge bg-info text-white">{this.props.t('agency_team.client_badge')}</span>
                        {user.client_name && <span className="team-client-name">{user.client_name}</span>}
                    </div>
                    {this.renderClientFeatureBadges(user.client_features)}
                </div>
            );
        } else if (user.user_type === "Admin") {
            content = this.props.t('agency_team.role_admin');
        } else if (user.user_type === "Regular") {
            content = this.props.t('agency_team.role_regular');
        }
        return (<td>{content}</td>)
    }

    renderUserTypeColumnHeader() {
        if(!this.showUserTypeColumn())
            return;
        return (<th>{this.props.t('agency_team.role')}</th>)
    }

    refreshUserName(userData) {
        const teamWithModifiedUser = this.state.team.map((user) => {
            if (user.id === userData.userId) {
                return {
                    ...user,
                    name: userData.userName,
                }
            } else {
                return user
            }
        });
        this.setState({team: teamWithModifiedUser})
    }

    removeDeletedUser(userId) {
        const teamExcludingDeleted = this.state.team.filter((user) => {
            return (user.id !== userId);
        });
        this.setState({team: teamExcludingDeleted})
    }

    removeDeletedInvitation(invitationId) {
        const invitationExcludingDeleted = this.state.invitations.filter((invitation) => {
            return (invitation.id !== invitationId);
        });
        this.setState({invitations: invitationExcludingDeleted})
    }
}

const AgencyTeamContent = withTranslation()(AgencyTeamContentClass);

export default withRouterParams(AgencyTeam);
